// The web session hint (FR-020; research R4): "a refresh cookie may exist", so a page load tries a
// restore only when it is set. Not a credential and no personal data. Android never writes it.
import { Platform } from "react-native";

import { deviceStorage } from "@/lib/deviceStorage";

const KEY = "akaiva.sessionHint";

export const sessionHint = {
  async present(): Promise<boolean> {
    return Platform.OS === "web" && (await deviceStorage.get(KEY)) === "1";
  },
  async set(): Promise<void> {
    if (Platform.OS === "web") await deviceStorage.set(KEY, "1");
  },
  async clear(): Promise<void> {
    if (Platform.OS === "web") await deviceStorage.remove(KEY);
  },
};
